import { render, staticRenderFns } from "./Fonts.vue?vue&type=template&id=5eeccc14&scoped=true&"
import script from "./Fonts.vue?vue&type=script&lang=js&"
export * from "./Fonts.vue?vue&type=script&lang=js&"
import style0 from "./Fonts.vue?vue&type=style&index=0&id=5eeccc14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eeccc14",
  null
  
)

export default component.exports